(function(){
  'use strict';
  if (window.__pfQtyInit) return;
  window.__pfQtyInit = true;

  function findOriginalQuantityInput(form) {
    if (!form) return null;
    var byFormAttr = document.querySelector('input[name="quantity"][form="' + form.id + '"]:not([data-pf-qty-display])');
    if (byFormAttr) return byFormAttr;
    var inForm = form.querySelector('input[name="quantity"]:not([data-pf-qty-display])');
    if (inForm) return inForm;
    return null;
  }

  function init() {
    document.querySelectorAll('[data-pf-qty]').forEach(function(wrapper) {
      if (wrapper.__pfQtyInit) return;
      wrapper.__pfQtyInit = true;

      var form = wrapper.closest('form');
      var display = wrapper.querySelector('[data-pf-qty-display]');
      var btns = wrapper.querySelectorAll('[data-pf-qty-action]');
      var original = findOriginalQuantityInput(form);

      var hidden = null;
      if (!original && form) {
        hidden = form.querySelector('input[name="quantity"][data-pf-qty-hidden]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'quantity';
          hidden.setAttribute('data-pf-qty-hidden', '');
          hidden.value = '1';
          form.appendChild(hidden);
        }
      }

      function setQty(n) {
        n = parseInt(n, 10);
        if (isNaN(n) || n < 1) n = 1;
        if (n > 99) n = 99;
        if (display) display.value = n;
        if (original) {
          original.value = n;
          try { original.dispatchEvent(new Event('change', { bubbles: true })); } catch(e){}
        }
        if (hidden) hidden.value = n;
      }

      btns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var cur = parseInt(display ? display.value : 1, 10) || 1;
          var dir = btn.dataset.pfQtyAction === 'inc' ? 1 : -1;
          setQty(cur + dir);
        });
      });

      if (display) {
        display.addEventListener('input', function() {
          var clean = display.value.replace(/\D/g, '');
          if (!clean) { display.value = ''; return; }
          setQty(clean);
        });
        display.addEventListener('blur', function() {
          if (!display.value || parseInt(display.value, 10) < 1) setQty(1);
        });
      }

      if (original && original.value && parseInt(original.value, 10) > 1) {
        setQty(original.value);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
